import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { COLOR_ORANGE } from '../styles/colors';

interface LoaderProps {
  className?: string;
  inProgress: boolean;
  spinnerClassName?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  loader: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.7)',
    zIndex: 1000,
    opacity: 0,
    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    pointerEvents: 'none',
  },
  loaderVisible: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  spinner: {
    color: COLOR_ORANGE,
  },
}), { name: Loader.name });

export default function Loader (props: LoaderProps) {
  const {
    className,
    inProgress = false,
    spinnerClassName = '',
  } = props;
  const classes = useStyles();

  if (!inProgress) return null;

  return (
    <div className={clsx(classes.loader, inProgress && classes.loaderVisible, className)}>
      <CircularProgress classes={{ root: clsx(classes.spinner, spinnerClassName) }} />
    </div>
  );
}
